module.exports = __webpack_public_path__ + "media/placeholder-images/placeholder_5-613603eb.jpg";